import { ReactNode } from "react";
import {
  AdvancedReportFilterType,
  AdvancedReportValueType,
} from "./useAdvancedReport";
import useAdvancedReportData, {
  AdvancedReportDataContext,
  AdvancedReportDataFilterType,
} from "./useAdvancedReportData";

export interface AdvancedReportDataProviderProps {
  children?: ReactNode;
  visibleValues?: AdvancedReportValueType[];
  visibleFilters?: AdvancedReportFilterType[];
  fixedFilter?: Partial<AdvancedReportDataFilterType>;
  dateType?: "travel" | "booking";
}

const AdvancedReportDataProvider: React.FC<AdvancedReportDataProviderProps> = ({
  children,
  visibleValues,
  visibleFilters,
  fixedFilter,
  dateType,
}) => {
  const context = useAdvancedReportData({
    visibleValues,
    visibleFilters,
    fixedFilter,
    dateType,
  });

  return (
    <AdvancedReportDataContext.Provider value={context}>
      {children}
    </AdvancedReportDataContext.Provider>
  );
};
export default AdvancedReportDataProvider;
